// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
    create(context, params) {
        return new Promise(resolve => {
            NewApiService.post(
                "order-discount/" + params.orderId,
                params.model
            ).then(({ data }) => {
                resolve(data);
            });
        });
    },
    delete(context, params) {
        return new Promise(resolve => {
            NewApiService.delete(
                `order-discount/${params.orderDiscountId}`,
                {}
            ).then(({ data }) => {
                resolve(data);
            });
        });
    },
    list() {
        return new Promise(resolve => {
            NewApiService.get("order-discount", {}).then(({ data }) => {
                resolve(data);
            });
        });
    },
};
